import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=7c54ab40"
import script from "./Web.vue?vue&type=script&lang=ts"
export * from "./Web.vue?vue&type=script&lang=ts"
import style0 from "./Web.vue?vue&type=style&index=0&id=7c54ab40&prod&lang=scss"
import style1 from "./Web.vue?vue&type=style&index=1&id=7c54ab40&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports